import React from 'react'
import BlueHeading from '../other/common/BlueHeading';
import Heading from '../common/ui/Heading';
import collbarteHeroImg from '../../assets/images/webp/collabration-hero-img.webp'
const CollabrationHero = () => {
  return (
    <>
      <div className="bg-[#EAF3EE] bg-cover bg-center bg-no-repeat px-4">
        <div className="max-w-[1140px] mx-auto flex items-center justify-between max-lg:gap-10 max-lg:flex-wrap max-lg:py-10">
          <div className="w-full max-w-[411px] max-lg:max-w-full">
            <BlueHeading text="Wellness Revolution" />
            <Heading
              children="Collaboration with Jeena Sikho"
              className="!text-6xl max-w-[404px] max-lg:max-w-full max-lg:!text-[50px] max-md:!text-4xl"
            />
            <p className="text-base font-normal leading-[150%] text-[#3B3B3B] pt-4 max-w-[376px] max-lg:max-w-full">
              Makeway India is proud to announce its exciting collaboration with
              Jeena Sikho, a global platform for wellness and sustainable
              living. This partnership focuses on bringing innovative technology
              to the world, with Magnetic Devices and Re-code Water Devices
              designed to improve health, productivity, and lifestyle.
            </p>
          </div>
          <div className="w-full max-w-[628px] max-lg:max-w-full my-[23px] max-lg:my-0">
            <img src={collbarteHeroImg} alt="collaborate" className="w-full" />
          </div>
        </div>
      </div>
    </>
  );
}

export default CollabrationHero